<template>
    <span data-test-id="pli-interval-label">{{ interval }}</span>
</template>

<script>
import { formatPliInterval } from '@/utils/pli-interval.js'

export default {
    props: ['row'],

    computed: {
        interval() {
            const interval = formatPliInterval(this.row.pli_interval_type, this.row.pli_interval_value)

            return interval === null ? 'N/A' : `Every ${interval.label}`
        },
    },
}
</script>
